import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from 'components/Icon';

import style from './AccordionItem.module.scss';

const AccordionItem = ({ headline = '', body = '', theme = {} }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={classNames(style.accordionItem, theme.accordionItem)}>
      <div className={classNames(style.content, theme.content)}>
        <button
          className={classNames(style.dropdownButton, theme.dropdownButton)}
          onClick={() => setOpen(!open)}
        >
          <div className={classNames(style.title, theme.title)}>{headline}</div>
          <div className={classNames(style.icon, open && style.iconFlipped)}>
            <Icon icon="chevron-down" viewBox="0 0 11 6" color="white" />
          </div>
        </button>
      </div>
      <div
        className={classNames(
          style.info,
          theme.info,
          open && style.infoOpen,
          open && theme.infoOpen,
        )}
      >
        {body}
      </div>
    </div>
  );
};

AccordionItem.propTypes = {
  headline: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  theme: PropTypes.shape({}),
};
export default AccordionItem;
